import React from "react";

const Administration = () => {
  return (
    <>
      <h2>Admin page</h2>
    </>
  );
};

export default Administration;
